exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sms{min-height:100%;background:#fff}", ""]);

// exports
